import ScrollToTopButton from "../components/ScrollToTopButton";
import {
  Banner,
  ContactImage,
  PhoneCall,
  Location,
  Fax,
  IndIcon,
  USAIcon,
} from "../images/index";
import { useState, useEffect } from "react";
import Swal from "sweetalert2";
import useSlug from "./SlugComp";
import SEO from "./Seo";
import { getPagesBySlug } from "../services/apiService";

const socialLinks = [
  // { icon: "fab fa-facebook-f", label: "Facebook", href: "#" },
  {
    icon: "fab fa-linkedin-in",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/techprojects/",
  },
  {
    icon: "fab fa-instagram",
    label: "Instagram",
    href: "https://www.instagram.com/p/DRACmzgk7PN/",
  },
  {
    icon: "fa-brands fa-x-twitter",
    label: "Twitter",
    href: "https://x.com/TechProjectsDev",
  },
  // { icon: "fab fa-dribbble", label: "Dribbble", href: "#" },
];

const socialConnect = [
  // { icon: "fab fa-youtube", label: "Youtube", href: "#" },
  {
    icon: "fab fa-linkedin-in",
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/techprojects/",
  },
  // { icon: "fab fa-facebook-f", label: "Facebook", href: '#'},
  {
    icon: "fab fa-instagram",
    label: "Instagram",
    href: "https://www.instagram.com/p/DRACmzgk7PN/",
  },
  {
    icon: "fa-brands fa-x-twitter",
    label: "Twitter",
    href: "https://x.com/TechProjectsDev",
  },
];

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobileNumber: "",
    subject: "",
    company: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [submitted, setSubmitted] = useState(false);
  const [metaData, setMetaData] = useState({});
  const slug = useSlug();

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const slugData = await getPagesBySlug(slug.toLowerCase());
        setMetaData(slugData.data);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      }
    };

    fetchJobs();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "mobileNumber") {
      const numericValue = value.replace(/\D/g, "").slice(0, 10);
      setFormData((prev) => ({ ...prev, [name]: numericValue }));
    } else if (name === "name") {
      const alphaNumericValue = value.replace(/[^a-zA-Z\s]/g, "");
      setFormData((prev) => ({ ...prev, [name]: alphaNumericValue }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }

    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setSubmitted(true);
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(formData.email)) {
      newErrors.email =
        "Please enter a valid email address (e.g., name@example.com).";
    }
    if (!formData.mobileNumber.trim())
      newErrors.mobileNumber = "Mobile Number is required.";
    if (!formData.subject.trim()) newErrors.subject = "Subject is required.";

    if (!formData.message.trim()) newErrors.message = "Message is required.";

    setErrors(newErrors);

    if (Object.keys(newErrors).length === 0) {
      fetch("http://65.2.137.148:5000/contactUs", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          company_name: formData.company,
          mobileNumber: formData.mobileNumber,
        }),
      })
        .then(async (response) => {
          console.log(response);
          if (!response.ok) {
            const errorText = await response.text();
            throw new Error(
              errorText || `HTTP error! status: ${response.status}`
            );
          }
          return response.text();
        })
        .then((data) => {
          Swal.fire({
            icon: "success",
            title: "Success!",
            text: "Form submitted successfully!",
            confirmButtonColor: "#3085d6",
          });
          setFormData({
            name: "",
            email: "",
            subject: "",
            company: "",
            message: "",
            mobileNumber: "",
          });
          setSubmitted(false);
        })
        .catch((error) => {
          Swal.fire({
            icon: "error",
            title: "Failed!",
            text: "Failed to submit form. Please try again.",
            confirmButtonColor: "#d33",
          });
        });
    }
  };

  const inputClass = (field) =>
    `w-full border rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 ${
      submitted && errors[field] ? "border-red-500" : "border-gray-300"
    }`;

  return (
    <>
      <SEO {...metaData} />
      <div>
        <div className="relative min-h-[630px]">
          <img
            src={Banner}
            alt="About Banner"
            className="absolute inset-0 h-full w-full "
          />

          <div className="absolute flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-8 sm:px-6 md:px-8 lg:px-8 xl:px-0">
            <div className="max-w-2xl font-roboto space-y-6">
              <span className="flex items-center font-bold text-lg tracking-wider space-x-2">
                <span className="w-[21px] h-[6px] bg-activeColor"></span>
                <span className="w-[36px] h-[6px] bg-activeColor"></span>
                <span className="text-[#475569] font-bold text-xl">
                  CONTACT US
                </span>
              </span>
              <h1 className="text-4xl md:text-7xl text-[#29327f] font-bold">
                Let’s Build the Future Together
              </h1>
              <p className="text-md text-[#404040]">
                We’re here to answer your questions, explore opportunities, and
                help your business grow with scalable IT and talent solutions.
              </p>
            </div>

            <div className="max-w-xl flex justify-end">
              <img
                src={ContactImage}
                alt="IT Hiring"
                className="w-full h-auto"
              />
            </div>
          </div>
        </div>
        <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] py-[4rem] mx-auto bg-white rounded-xl overflow-hidden font-roboto px-6 md:px-0">
          <div className="grid gap-12">
            <div className="flex justify-between items-center px-5">
              <div>
                <p className="text-xl font-bold tracking-widest text-[#475569] uppercase mb-2">
                  Get Started
                </p>
                <h2 className="text-3xl md:text-6xl font-extrabold leading-tight text-[#0F172A]">
                  Get in touch with us. <br />
                  We’re here to assist you.
                </h2>
              </div>
              <div>
                <div className="grid space-y-3 text-black text-lg">
                  {socialLinks.map((item, index) => (
                    <a
                      target="_blank"
                      key={index}
                      href={item.href}
                      aria-label={item.label}
                      className="w-10 h-10 flex items-center justify-center border border-gray-300 rounded-full text-black hover:bg-gray-100 transition"
                      title={item.label}
                    >
                      <i className={item.icon}></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <form
              onSubmit={handleSubmit}
              className="flex-1 grid grid-cols-1 md:grid-cols-2 gap-6 px-5"
            >
              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Full name"
                  className={inputClass("name")}
                />
                {errors.name && (
                  <p className="text-red-500 text-sm mt-1">{errors.name}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Email <span className="text-red-500">*</span>
                </label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Email address"
                  className={inputClass("email")}
                />
                {errors.email && (
                  <p className="text-red-500 text-sm mt-1">{errors.email}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Mobile No <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="mobileNumber"
                  value={formData.mobileNumber}
                  onChange={handleChange}
                  placeholder="Mobile No"
                  className={inputClass("mobileNumber")}
                />
                {errors.mobileNumber && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.mobileNumber}
                  </p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Subject <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  placeholder="Subject"
                  className={inputClass("subject")}
                />
                {errors.subject && (
                  <p className="text-red-500 text-sm mt-1">{errors.subject}</p>
                )}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Company Name
                </label>
                <input
                  type="text"
                  name="company"
                  value={formData.company}
                  onChange={handleChange}
                  placeholder="Company"
                  className={inputClass("company")}
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-600 mb-2">
                  Message <span className="text-red-500">*</span>
                </label>
                <textarea
                  name="message"
                  rows="4"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Tell us about your project..."
                  className={inputClass("message")}
                ></textarea>
                {errors.message && (
                  <p className="text-red-500 text-sm mt-1">{errors.message}</p>
                )}
              </div>

              <div className="md:col-span-2">
                <button
                  type="submit"
                  className="bg-activeColor text-white px-6 py-3 rounded-md font-semibold hover:bg-red-600 transition-all"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>

        <section className="bg-[#29327F] ml-3 mr-3 font-roboto text-white py-16 px-6 md:px-16 sm:w-[75rem] rounded-3xl [@media(min-width:1920px)]:w-[84rem] md:mx-auto relative overflow-hidden">
          <div className="absolute top-[93px] right-[112px] w-20 h-20 bg-white/10 rotate-45 translate-x-24 -translate-y-16 rounded-2xl"></div>
          <div className="absolute top-[158px] right-[176px] w-20 h-20 bg-white/10 rotate-45 translate-x-24 -translate-y-16 rounded-2xl"></div>
          <div className="absolute top-[30px] right-[44px] w-20 h-20 bg-white/10 rotate-45 translate-x-20 translate-y-20 rounded-2xl"></div>
          <div className="absolute top-[96px] right-[107px] w-20 h-20 bg-white/10 rotate-45 translate-x-20 translate-y-20 rounded-2xl"></div>

          <div className="relative z-10 text-center md:text-left mb-12">
            <h2 className="text-4xl md:text-5xl font-extrabold mb-5">
              Our Locations
            </h2>
            <p className="font-400 text-xl">
              Explore our core capabilities that power digital transformation
              and enterprise success.
            </p>
          </div>

          <div className="relative z-10 grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-20">
            <div>
              <div className="flex items-center ml-2 gap-8 mb-6">
                <img src={IndIcon} alt="India" className="" />
                <h3 className="text-4xl font-bold font-inter">India</h3>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="flex items-center justify-center w-[64px] h-[64px] bg-white/10 rounded-full">
                  <img src={PhoneCall} alt="Phone" className="object-contain" />
                </div>
                <div>
                  <p className="text-gray-400 font-400 text-sm font-inter tracking-widest">
                    PHONE NUMBER
                  </p>
                  <p className="text-xl font-400 font-inter">+91 9951888536</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-[80px] h-[64px] bg-white/10 rounded-full">
                  <img
                    src={Location}
                    alt="Location"
                    className="object-contain"
                  />
                </div>
                <div className="w-full">
                  <p className="text-gray-400 font-400 text-sm font-inter tracking-widest">
                    HYDERABAD - TELANGANA - INDIA
                  </p>
                  <p className="text-xl font-400 font-inter">
                    Orbit, 2nd floor, Unit -01, Plot No 30/C, Sy No 83/1,
                    Hyderabad Knowledge City Raidurg Panmaktha, Serilingampally
                    Mandal, Hyderabad, Telangana 500081, India
                  </p>
                </div>
              </div>
            </div>

            {/* USA */}
            <div>
              <div className="flex items-center ml-2 gap-8 mb-6">
                <img src={USAIcon} alt="USA" className="" />
                <h3 className="text-4xl font-bold font-inter">USA</h3>
              </div>

              <div className="flex items-start gap-4 mb-6">
                <div className="flex items-center justify-center w-[64px] h-[64px] bg-white/10 rounded-full">
                  <img src={PhoneCall} alt="Phone" className="object-contain" />
                </div>
                <div>
                  <p className="text-gray-400 font-400 text-sm font-inter tracking-widest">
                    PHONE NUMBER
                  </p>
                  <p className="text-xl font-400 font-inter">+1-732-828-9900</p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="flex items-center justify-center w-[80px] h-[64px] bg-white/10 rounded-full">
                  <img
                    src={Location}
                    alt="Location"
                    className="object-contain"
                  />
                </div>
                <div className="w-full">
                  <p className="text-gray-400 font-400 text-sm font-inter tracking-widest">
                    NORTH BRUNSWICK - NEW JERSEY - USA
                  </p>
                  <p className="text-xl font-400 font-inter">
                    850 Carolier Ln, suite #102, North Brunswick, NJ, 08902
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <div className="sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] py-12 mx-auto bg-white rounded-xl overflow-hidden flex flex-col md:flex-grid font-inter">
          <div className="w-full h-[400px] md:h-[500px] rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps?q=Orbit by Auro Realty, Hyderabad&z=15&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
          <div className="flex items-center py-6 font-roboto space-x-[8rem] px-6 md:px-0">
            <h1 className="font-bold text-4xl text-[#434253]">
              Social Connect
            </h1>
            <div className="flex space-x-8 text-[#062B96] text-3xl">
              {socialConnect.map((item, index) => (
                <a
                  target="_blank"
                  key={index}
                  href={item.href}
                  aria-label={item.label}
                  className=""
                  title={item.label}
                >
                  <i className={item.icon}></i>
                </a>
              ))}
            </div>
          </div>
        </div>
        {/* <div
        className="w-full h-[320px] bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${BlueCard})` }}
      >
        <div className="flex items-center justify-between h-full sm:w-[75rem] [@media(min-width:1920px)]:w-[84rem] mx-auto left-0 right-0 px-6 md:px-0">
          <div className="max-w-2xl font-roboto space-y-6 grid grid-cols-1 md:grid-cols-1 gap-6">
            <div>
              <span className="text-4xl text-white font-bold">
                Looking for a partner to accelerate your business
                transformation?
              </span>
            </div>
            <div>
              <button
                type="submit"
                className="bg-activeColor text-white px-6 py-3 rounded-md font-500 hover:bg-red-600 transition-all"
              >
                Schedule a Call
              </button>
            </div>
          </div>

          <div className="max-w-xl flex justify-end">
            <img src={Client} alt="Schedule Call" className="w-full h-auto" />
          </div>
        </div>
      </div> */}
        <ScrollToTopButton />
      </div>
    </>
  );
}

export default Contact;
